import { updateFiltersFront, setKeyFilterSelected } from "../../../redux/actions/pdcActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filters";

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.pdcs.filters ? state.pdcs.filters[ownProps.filterTargetKey] : [],
    currentFilters: state.pdcs.currentFilters ? state.pdcs.currentFilters[ownProps.filterTargetKey] : [],
    deps: ownProps.depKey && state.pdcs.currentFilters ? state.pdcs.currentFilters[ownProps.depKey] || [] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder,
    maxItemsToDisplay: 5000
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFiltersFront(ownProps.filterTargetKey, values));
    },
    setKeyFilterSelected: () => {
      dispatch(setKeyFilterSelected(ownProps.filterTargetKey));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);



// WEBPACK FOOTER //
// src/containers/metier/pdcs/FilterContainer.js